import Api from '@/services/Api'

export default {
  fetchItems () {
    return Api().get('items')
  },

  addItem (item) {
    return Api().post('items', item)
  },

  addCustomCurtain (item) {
    return Api().post('customCurtains', item)
  },

  getCustomCurtains (id) {
    return Api().get('customCurtainsOfOrder/' + id)
  },

  updateItem (params) {
    return Api().put('item/' + params._id, params)
  },
  updateQuantity (params) {
    return Api().post('item/updateQuantity', params)
  },

  updateCustomCurtain (params) {
    return Api().put('customCurtains/' + params._id, params)
  },

  getItem (params) {
    return Api().get('item/' + params.id)
  },
  getItemsWithMotors () {
    return Api().get('getItemsWithMotors')
  },

  deleteItem (id) {
    return Api().delete('item/' + id)
  },

  deleteCustomCurtain (id) {
    return Api().delete('customCurtains/' + id)
  },

  getPricing (item) {
    return Api().post('pricing/', {
      item: item
    })
  },

  importItem (item) {
    return Api().post('items/import', {
      item: item
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/ItemService.js